import React, { MouseEventHandler, ReactElement, ReactNode } from 'react';
import { CloseGreenIcon } from '@root/src/assets/images';
import {
  CloseButton,
  DangerButton,
  IconButton,
  PrimaryButton,
  SecondaryButton,
  TertiaryButton,
} from './styled';

export type ButtonType =
  | 'primary'
  | 'secondary'
  | 'tertiary'
  | 'danger'
  | 'icon'
  | 'close';

type ButtonClickEventHandlerI =
  | MouseEventHandler<HTMLButtonElement>
  | undefined;

export type ButtonOrSvgClickEventHandlerI =
  | MouseEventHandler<SVGElement | HTMLButtonElement>
  | undefined;

export interface PropsI {
  label?: ReactNode;
  'aria-label'?: string;
  type?: ButtonType;
  icon?: ReactElement;
  disabled?: boolean;
  'data-testid'?: string;
  className?: string;
  onClick?: ButtonClickEventHandlerI;
  noFill?: boolean;
  roundLeft?: boolean;
  roundRight?: boolean;
  as?: 'button' | 'a';
  href?: string;
}

const Button = ({
  type = 'primary',
  icon,
  label,
  ...props
}: PropsI): React.ReactElement => {
  switch (type) {
    case 'secondary':
      return (
        <SecondaryButton label={label} {...props}>
          {icon}
          {label}
        </SecondaryButton>
      );
    case 'tertiary':
      return (
        <TertiaryButton label={label} {...props}>
          {icon}
          {label}
        </TertiaryButton>
      );
    case 'danger':
      return (
        <DangerButton label={label} {...props}>
          {icon}
          {label}
        </DangerButton>
      );
    case 'icon':
      return (
        <IconButton {...props}>
          {icon}
          {label}
        </IconButton>
      );
    case 'close':
      return (
        <CloseButton {...props}>
          <CloseGreenIcon />
        </CloseButton>
      );
    case 'primary':
    default:
      return (
        <PrimaryButton icon={icon} label={label} {...props}>
          {icon}
          {label}
        </PrimaryButton>
      );
  }
};

export default Button;
